import ButtonDelete from './ButtonDelete';

ButtonDelete.install = function(Vue) {
  Vue.component(ButtonDelete.name, ButtonDelete);
};

export default ButtonDelete;
